<template>
    <div>
        <form class="form-horizontal" v-if="repetidor">

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                </div>
                <div class="panel-body">
                    <div class="form-group">

                        <div class="col-sm-10">
                            <label class="control-label">NOME DO REPETIDOR</label><br/>
                            <input :disabled="user.level >= 5" type="text" v-model="repetidor.nome" class="form-control" >
                        </div>

                        <div class="col-sm-2">
                            <label class="control-label">RAIO</label>
                            <input type="text" v-model.number="repetidor.radius" class="form-control" >
                        </div>

                    </div>
                </div>
            </div>

            <ssh v-if="user.level === 1" :ssh="repetidor.ssh"></ssh>

            <geocode v-if="user.level === 1" :geocode="repetidor.geocode"></geocode>

            <div class="form-group">
                <div class="col-sm-10">
                    <button type="button" v-if="user.level < 5"
                            @click="save()"
                            class="btn btn-success">
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR REPETIDOR
                    </button>
                </div>
            </div>

        </form>
    </div>
</template>
<script>
import { Repetidor } from "../../../class/index";
import { Ssh, Geocode } from "../../../components/exports";
import pontoComputedMixin from "../../mixins/repetidores_computed";

export default {
    components: {
        Ssh,
        Geocode
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    mixins: [pontoComputedMixin],
    data() {
        return {
            user: null
        };
    },
    methods: {
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o repetidor?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Repetidor.save(this.repetidor)
                                .then(() => {
                                    resolve();
                                    this.$router.push({ path: "/repetidores" });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
